var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import { Platform } from 'react-native';
import { component } from '../../Decorators/Component';
import { LoadingView } from '../Common/LoadingView';
import { InlineModalView } from '../Modals/InlineModal';
import { CoreConfig } from './../../../CoreConfig';
import { Configuration } from './../../../Domain/DTOs/Configuration/ConfigurationDTO';
let LoadingPopUpView = class LoadingPopUpView extends Component {
    render() {
        var _a, _b;
        return (_jsx(InlineModalView, { visible: !!this.props.visible, animationDuration: 150, delayHide: this.props.delayHide, wrapperStyle: Object.assign(Object.assign({}, (_a = this.props.style) === null || _a === void 0 ? void 0 : _a.wrapper), this.props.wrapperStyle), containerStyle: (_b = this.props.style) === null || _b === void 0 ? void 0 : _b.modalContainer, children: _jsx(LoadingView, {}) }));
    }
};
LoadingPopUpView = __decorate([
    component({
        provider: CoreConfig.provider,
        moduleName: CoreConfig.moduleName,
        componentName: Configuration.ComponentNames.loadingPopUp,
        style: {
            modalContainer: Object.assign(Object.assign({ padding: 25 }, Platform.select({
                android: {
                    elevation: 5,
                    shadowColor: '#000',
                    shadowOffset: {
                        width: 0,
                        height: 0,
                    },
                    shadowOpacity: 0.23,
                    shadowRadius: 70,
                },
                default: {
                    shadowColor: '#000',
                    shadowOffset: {
                        width: 0,
                        height: 0,
                    },
                    shadowOpacity: 0.23,
                    shadowRadius: 70,
                },
            })), { backgroundColor: '#fff' })
        }
    })
], LoadingPopUpView);
export { LoadingPopUpView };
